import React from 'react'
import { SecondaryLink } from 'stylist'
import { isAbsoluteUrl } from 'utils/url'
import { captureInsecureRedirect } from 'utils/sentry'

const SmartSecondaryLink = ({ url, children }) => {
  return isAbsoluteUrl(url) ? (
    <SecondaryLink
      external
      href={url}
      onClick={e => {
        e.preventDefault()
        captureInsecureRedirect(url, () => (window.location.href = url))
      }}
    >
      {children}
    </SecondaryLink>
  ) : (
    <SecondaryLink to={url}>{children}</SecondaryLink>
  )
}

export default SmartSecondaryLink



// WEBPACK FOOTER //
// ./src/components/SmartSecondaryLink.js